import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { QuotationComponent } from './quotation/quotation.component';

export enum routePath {
  QUOTATION = 'home',
  CUSTOMERINFO = 'customer-info'
}

export const routes: Routes = [
  { path: '', redirectTo: '/' + routePath.QUOTATION, pathMatch: 'full' },
  {
    path: routePath.QUOTATION,
    component: QuotationComponent
  },
  {
    path: routePath.CUSTOMERINFO,
    loadChildren: () => import('./customer-info/customer-info.module').then(m => m.CustomerInfoModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
